import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NOINDEX_PREFIXES = ["/dashboard", "/wallet", "/login", "/request-access"];

function setMetaTag(name: string, content: string, property = false) {
  const attr = property ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setCanonical(href: string) {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
}

export function useRouteSEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldNoindex = NOINDEX_PREFIXES.some(
      (p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p)
    );

    setMetaTag("robots", shouldNoindex ? "noindex, nofollow" : "index, follow");

    if (!shouldNoindex) {
      setCanonical(`https://flowstate.ge${pathname === "/" ? "/" : pathname}`);
      setMetaTag("og:url", `https://flowstate.ge${pathname === "/" ? "/" : pathname}`, true);
    }
  }, [pathname]);
}
